export default function header(vm) {
  return [
    { text: vm.$t('history.step'), value: 'step', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.rt'), value: 'respti', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.wait'), value: 'queueti', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.rollin'), value: 'rollinti', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.loadgen'), value: 'loadgentime', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.proc'), value: 'procti', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.db'), value: 'dbtime', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.lock'), value: 'lockti', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.rollwait'), value: 'rolledOut', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.cpu'), value: 'cputi', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.gui'), value: 'guitime', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.rfc'), value: 'rfcti', sortable: false, align: 'end' },
    { text: vm.$t('hist.title.avg.fenet'), value: 'guinettime', sortable: false, align: 'end' },
  ];
}
